import React from 'react';
import './hemisphere.css';
import north from './image/northern.gif';
import south from './image/south.gif';

const HemisphereConfig={
 Northern:{
 	text:'You are in Northern hemisphere',
 	picture: north
 },
  Southern:{
  	text:'You are in Southern hemisphere',
 	picture: south	
 }
}

const HemisphereDisplay=( {latitude} )=>{
	
	const hemisphere= latitude > 0 ? 'Northern' : 'Southern';
	const{text,picture}=HemisphereConfig[hemisphere];
 
	return(
		<div className={hemisphere}>
		    <div className="ui raised text container segment">	
			 <div className="image">
			   <img src={picture} alt="hemisphere" />
			 </div>
			 <div className="ui teal bottom attached label">
			   <h1>{text}</h1>
			 </div>
			</div>		
		</div>

		)
}

export default HemisphereDisplay;